var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useContext } from "react";
import { Stack, ListItem, ListItemAvatar, ListItemButton } from "@mui/material";
import { Text } from "../../../../../Atoms";
import BrokerLogo from "../BrokerLogo";
import { PAGE } from "../../../constants";
import { Context } from "../../../context";
import { EventName, track } from "../../../../../../analytics";
var textStyles = {
    width: "100%",
    whiteSpace: "nowrap",
    overflowX: "hidden",
    textOverflow: "ellipsis",
};
var BrokerListItem = function (_a) {
    var _b, _c;
    var broker = _a.broker, showBorder = _a.showBorder;
    var _d = useContext(Context), setPage = _d.setPage, setSelectedBroker = _d.setSelectedBroker, product = _d.product, clientName = _d.clientName;
    var selectBroker = useCallback(function () {
        var _a, _b;
        setSelectedBroker(broker);
        setPage(PAGE.OTP_EMAIL);
        track({
            name: EventName.PartnerBrokerSelected,
            product: product,
            auth_client: clientName,
            broker_id: broker.globalBrokerId,
            broker_name: broker.name,
            logo_available: !!((_a = broker === null || broker === void 0 ? void 0 : broker.theme) === null || _a === void 0 ? void 0 : _a.logo) || !!((_b = broker === null || broker === void 0 ? void 0 : broker.theme) === null || _b === void 0 ? void 0 : _b.mobileLogo),
        });
    }, [broker]);
    return (_jsx(ListItem, __assign({ sx: {
            borderBottom: showBorder ? "1px solid #EBEBEB" : "",
            display: "flex",
            padding: 0,
        } }, { children: _jsxs(ListItemButton, __assign({ sx: { padding: "8px 10px" }, onClick: selectBroker }, { children: [_jsx(ListItemAvatar, { children: _jsx(BrokerLogo, { logo: ((_b = broker === null || broker === void 0 ? void 0 : broker.theme) === null || _b === void 0 ? void 0 : _b.mobileLogo) || ((_c = broker === null || broker === void 0 ? void 0 : broker.theme) === null || _c === void 0 ? void 0 : _c.logo), diameter: 36 }) }), _jsxs(Stack, __assign({ sx: {
                        minHeight: "48px",
                        justifyContent: "center",
                    } }, { children: [_jsx(Text, __assign({ variant: "body1", sx: textStyles }, { children: broker.name })), broker.website ? (_jsx(Text, __assign({ category: "primary", shade: "dark", emphasis: "medium_low", variant: "body1", sx: textStyles }, { children: broker.website }))) : null] }))] })) })));
};
export default React.memo(BrokerListItem);
